import React from "react";
import { Stack, Group, ActionIcon, Text } from "@mantine/core";
import { IconChevronLeft } from "@tabler/icons-react";
import WebsiteGeneratorThemeOptions from "./WebsiteGeneratorThemeOptions";

interface ThemeSectionProps {
  selectedTheme: string;
  onThemeSelect: (theme: string) => void;
  onBack: () => void;
}

const ThemeSection: React.FC<ThemeSectionProps> = ({
  selectedTheme,
  onThemeSelect,
  onBack,
}) => {
  return (
    <Stack gap="md">
      <Group justify="space-between" align="center">
        <ActionIcon variant="subtle" onClick={onBack}>
          <IconChevronLeft size={16} />
        </ActionIcon>
        <Text fw={600} size="lg">
          Theme
        </Text>
      </Group>
      <WebsiteGeneratorThemeOptions
        selectedTheme={selectedTheme}
        onThemeSelect={onThemeSelect}
      />
    </Stack>
  );
};

export default ThemeSection;
